import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './styles.css';

const container = document.getElementById('root');

// index.html always contains this element, so its absence means the HTML and
// this bundle have gone out of step — worth an explicit error rather than a
// blank page and a null-reference in the console.
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
